/**
 * Typen der Seite „Funktionserhalt-Systemnachweis" (W2-C3, 16.10.2026). Die
 * Felder entsprechen der JSON-Route `GET …/elektro/funktionserhalt`
 * (Funktionserhaltlauf).
 */

export const PDF_HINWEIS =
  'Der PDF-Abruf legt nur bei geändertem Stand eine neue Berichtsfassung mit neuer Dokumentnummer an; '
  + 'sonst liefert er die abgelegte Fassung (F11).';

export const ABSCHAETZUNG_HINWEIS =
  'Die Belegung je Trasse ist nicht modelliert. Füllgrad und Last sind eine Abschätzung je Geschoss '
  + '(Mittelwert über alle Trassen derselben Funktionserhaltklasse, Kabel im Geschoss ihres Verteilers).';

export interface FeKennzahlen {
  kabelbemessungGelaufen: boolean; kabellaufAm: string | null; svKreise: number; svZuleitungen: number;
  zugeordnet: number; offen: number; warnungen: number; e30TrasseM: number; e90TrasseM: number; e90BedarfM: number;
  befunde: number; aufAnnahmen: boolean;
}

export interface FeMatrixzeile {
  anlage: string; titel: string; soll: string; muster: string; kreise: number; warnungen: number; bestaetigt: boolean;
}

export interface FeKreis {
  art: string; kennzeichen: string; verteiler: string; geschoss: string | null; bezeichnung: string | null;
  kabeltyp: string | null; anlage: string | null; anlageTitel: string | null; soll: string; ist: string;
  laengeM: number | null; status: string; befunde: string[];
}

export interface FeGeschoss {
  geschoss: string; klasse: string; trassen: number; trassenLaengeM: number; trassenVolumenMm2M: number; ohneMass: number;
  kabel: number; kabelLaengeM: number; kabelVolumenMm2M: number; kabelMasseKg: number; fuellgradProzent: number | null;
  lastKgJeM: number | null; lastZulKgJeM: number | null; status: string; befunde: string[];
}

export interface FeVorgabe {
  feld: string; verwendung: string | null; wert: string; einheit: string; bestaetigt: boolean; herkunft: string;
  normbezug: string; rueckfall: boolean;
}

export interface FunktionserhaltStand {
  kennzahlen: FeKennzahlen;
  matrix: FeMatrixzeile[];
  kreise: FeKreis[];
  geschosse: FeGeschoss[];
  tragsysteme: { klasse: string; typ: string; teile: number; laengeM: number }[];
  e90: { kreise: number; kabelLaengeM: number; trassenLaengeM: number; trassenGeschosse: number; befunde: string[] };
  vorgaben: FeVorgabe[];
  befunde: string[];
  stand: string | null;
}
